import { Grid2 } from "@mui/material";
import React from "react";
import AnalyticsBox from "../Common/AnalyticsBox";

const AnalyticsBoxes = ({
  setCalenderComponentState,
  isSubscribed,
  teir,
  visitingId,
  isAdmin,
  data,
}) => {
  return (
    <Grid2 container spacing={2} sx={{ mt: 4 }}>
      <AnalyticsBox title="Post" number={data ? data.posts : "0"} />

      <AnalyticsBox
        title="Subscribers"
        number={data ? data.subscribers : "0"}
      />

      <AnalyticsBox title="followers" number={data ? data.followers : "0"} />

      {!isAdmin && (
        <AnalyticsBox
          title="Calendar"
          setCalenderComponentState={setCalenderComponentState}
          isSubscribed={isSubscribed}
          isAdmin={isAdmin}
          schedule
          teir={teir}
          visitingId={visitingId}
        />
      )}
    </Grid2>
  );
};

export default AnalyticsBoxes;
